(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sereve-product"]) return;
  try {
    
document.addEventListener('click', function (e) {
  var t = e.target.closest('.sv-thumb');
  if (!t) return;
  var f = t.getAttribute('data-full');
  var m = document.getElementById('svMainImg');
  if (m && f) m.src = f;
  document.querySelectorAll('.sv-thumb').forEach(function (x) { x.classList.remove('active'); });
  t.classList.add('active');
});
document.addEventListener('change', function (e) {
  if (!e.target.matches('.sv-variant input')) return;
  var r = e.target;
  document.querySelectorAll('.sv-variant').forEach(function (l) { l.classList.remove('sel'); });
  var lab = r.closest('.sv-variant');
  if (lab) lab.classList.add('sel');
  var p = r.getAttribute('data-price');
  var c = r.getAttribute('data-compare') || '';
  var e1 = document.getElementById('svPrice'); if (e1) e1.textContent = p;
  var e2 = document.getElementById('svAtcPrice'); if (e2) e2.textContent = p;
  var e3 = document.getElementById('svCompare'); if (e3) e3.textContent = c;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpb-content"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[id^="tpb-ct-"]').forEach(function(root){
    var rise = root.querySelectorAll('.tpb-rise');
    if (reduce || !('IntersectionObserver' in window)) { rise.forEach(function(e){ e.classList.add('tpb-on'); }); }
    else {
      var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('tpb-on'); io.unobserve(x.target); } }); }, {threshold:.12});
      rise.forEach(function(e){ io.observe(e); });
    }
    var cus = root.querySelectorAll('.tpb-cu');
    function countUp(el){
      var raw = (el.getAttribute('data-to')||'').replace(/[^0-9]/g,'');
      var to = parseInt(raw,10); if(isNaN(to)) return;
      if (reduce){ el.textContent = to.toLocaleString(); return; }
      var start=null, dur=1400;
      function step(ts){ if(!start) start=ts; var p=Math.min((ts-start)/dur,1); el.textContent=Math.floor(p*to).toLocaleString(); if(p<1){ requestAnimationFrame(step); } else { el.textContent=to.toLocaleString(); } }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window){
      var io2 = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ countUp(x.target); io2.unobserve(x.target); } }); }, {threshold:.5});
      cus.forEach(function(e){ io2.observe(e); });
    } else { cus.forEach(countUp); }
    root.querySelectorAll('.tpb-final-cta').forEach(function(a){
      a.addEventListener('click', function(e){
        var href = a.getAttribute('href')||'';
        if (href.indexOf('#tpb-bx') === 0 || href === '#tpb-bx-top'){
          e.preventDefault();
          var bx = document.querySelector('.tpb-buybox-section') || document.querySelector('[id^="tpb-bx-"]');
          if (bx){ bx.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'start'}); }
          else { window.scrollTo({top:0, behavior: reduce ? 'auto' : 'smooth'}); }
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
